module.exports = __webpack_public_path__ + "static/media/reducer-if.4e3bd654.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/reducer-if.png
// module id = 82
// module chunks = 0